import { OrgMember } from 'src/types';

export const emailExists = (
  users: OrgMember[],
  inviteList: { email: string }[],
  email: string,
) => {
  // if the email exists in the array of users or the emailsToInvite array
  if (
    users.some((user) => user.email === email) ||
    inviteList.some((e) => e.email === email)
  ) {
    return true;
  }

  return false;
};
